import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'src/store/store';
import AustinOption from './austinOption';
import BaliOrDaliOption from './baliOrDaliOption';
import ButtonGroup from '@amzn/meridian/button-group';
import { BackgroundFormData } from 'src/store/newJmrPageSlice/types';
import { COUNTRY_ID_MAPPING } from 'src/config/CountryIdMapping';
import { CaseSources } from 'src/utils/jmrUtils';

interface AdminOptionProps {
  handleChange: (key: keyof BackgroundFormData, value: any) => void;
}

const AdminOption = ({ handleChange }: AdminOptionProps) => {
  const { backgroundFormData } = useAppSelector((state) => state.newJmrPage);
  const isCanadian = backgroundFormData.site?.countryId === COUNTRY_ID_MAPPING.CANADA_COUNTRY_ID;
  const [baliOrDali, setbaliOrDali] = useState(CaseSources.Dali);

  useEffect(
    () => (isCanadian ? setbaliOrDali(CaseSources.Bali) : setbaliOrDali(CaseSources.Dali)),
    [backgroundFormData.site?.countryId],
  );

  return (
    <ButtonGroup
      value={backgroundFormData?.caseSource}
      onChange={(caseSource) => {
        handleChange('caseSource', caseSource);
      }}
    >
      <AustinOption disabled={false}></AustinOption>
      <BaliOrDaliOption disabled={false} baliOrDali={baliOrDali}></BaliOrDaliOption>
    </ButtonGroup>
  );
};

export default AdminOption;
